export default {
  getOcorrencia: state => id => state.ocorrencias.find(item => item.id === id),
}
